import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, TextField, Typography } from '@iho-design-system/Loader';


const ExtraPassenger = ({ reserveRoomsResult, maxExtraPersonCountResult, requestType, sendRequestStatusProps, extraPassengerProps }) => {

    /*
        -defaultData
    */
    const [extraPassengerTicket, setExtraPassengerTicket] = React.useState({});
    const [extraPassenger, setExtraPassenger] = React.useState({});

    /*
        - increasePassengerNumber
    */
    const increasePassengerNumber = (maxExtraPersonCount, currentNumber, room, id) => {
        if ((currentNumber === undefined || currentNumber === '') && maxExtraPersonCount > 0) {
            setExtraPassengerTicket(prev => ({ ...prev, [id]: `تعداد 1 نفر برای ${room.RoomName} مهمان ${room.FirstName} ${room.LastName} افزوده شود` }));
            setExtraPassenger(prev => ({ ...prev, [id]: 1 }));
        } else if (currentNumber >= 0 && currentNumber < maxExtraPersonCount) {
            setExtraPassengerTicket(prev => ({ ...prev, [id]: `تعداد ${currentNumber + 1} نفر برای ${room.RoomName} مهمان ${room.FirstName} ${room.LastName} افزوده شود` }));
            setExtraPassenger(prev => ({ ...prev, [id]: currentNumber + 1 }));
        } else if (currentNumber === maxExtraPersonCount) {
            setExtraPassengerTicket(prev => ({ ...prev, [id]: `تعداد ${maxExtraPersonCount} نفر برای ${room.RoomName} مهمان ${room.FirstName} ${room.LastName} افزوده شود` }));
            setExtraPassenger(prev => ({ ...prev, [id]: maxExtraPersonCount }));
        } else {
            setExtraPassengerTicket(prev => ({ ...prev, [id]: '' }));
            setExtraPassenger(prev => ({ ...prev, [id]: 0 }));
        }
    }

    /*
        - decreasePassengerNumber
    */
    const decreasePassengerNumber = (maxExtraPersonCount, currentNumber, room, id) => {
        console.log(currentNumber)
        if (currentNumber > 1 && currentNumber <= maxExtraPersonCount) {
            setExtraPassengerTicket(prev => ({ ...prev, [id]: `تعداد ${currentNumber - 1} نفر برای ${room.RoomName} مهمان ${room.FirstName} ${room.LastName} افزوده شود` }));
            setExtraPassenger(prev => ({ ...prev, [id]: currentNumber - 1 }));
        } else {
            console.log('here')
            setExtraPassengerTicket(prev => ({ ...prev, [id]: '' }));
            setExtraPassenger(prev => ({ ...prev, [id]: 0 }));
        }
    }

    console.log(extraPassengerTicket)

    React.useEffect(() => {
        let keys = Object.keys(extraPassengerTicket);
        let sendRequestStatus = false;
        keys.forEach((obj) => {
            if (extraPassengerTicket[obj] !== '') {
                sendRequestStatus = true;
                extraPassengerProps(extraPassengerTicket);
            }
        });
        sendRequestStatusProps(sendRequestStatus);
    }, [extraPassengerTicket]);

    React.useEffect(() => {
        setExtraPassengerTicket({});
    }, [requestType]);

    return (

        <React.Fragment>

            {requestType.split(',')[1] === 'extraPassenger' && requestType.split(',')[3] === 'selectReserve' && requestType.split(',')[4] === undefined &&
                <Box
                    className={`w-100 my-lg mb-0 border-solid-top border-medium`}>
                    <Typography
                        className={`py-md`}
                        component='h5'>
                        لیست اتاق‌ها
                    </Typography>
                    <Box
                        className={`w-100`}
                        ms={{
                            maxHeight: '142px',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            opacity: '0',
                            animation: 'reserveAnimation 0.5s linear',
                            animationDelay: '1s',
                            animationFillMode: 'forwards',
                            '&::-webkit-scrollbar': {
                                width: '4px',
                                opacity: '0'
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: 'var(--blue-medium)',
                                borderRadius: 'var(--sizing-md)'
                            }
                        }}>
                        {reserveRoomsResult.map((obj, index) => {
                            return (
                                <Box
                                    key={index}
                                    className={`my-sm mt-0 rounded-sm`}
                                    ms={{
                                        backgroundColor: 'var(--gray-medium)'
                                    }}>
                                    <Grid>
                                        <Grid.Wrapper>
                                            <Grid.Item
                                                size='col-12'>
                                                <Typography>
                                                    نوع اتاق :
                                                </Typography>
                                                <Typography
                                                    className={`mx-xs ml-0 text-bold`}>
                                                    {obj.RoomName}
                                                </Typography>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-5'>
                                                <Typography>
                                                    نام :
                                                </Typography>
                                                <Typography
                                                    className={`mx-xs ml-0 text-bold`}>
                                                    {obj.FirstName}
                                                </Typography>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-7'>
                                                <Typography>
                                                    نام خانوادگی :
                                                </Typography>
                                                <Typography
                                                    className={`mx-xs ml-0 text-bold`}>
                                                    {obj.LastName}
                                                </Typography>
                                            </Grid.Item>
                                            <Grid.Item
                                                size='col-12'>
                                                <Box
                                                    ms={{
                                                        position: 'relative'
                                                    }}>
                                                    <Button
                                                        onClick={() => decreasePassengerNumber(maxExtraPersonCountResult, extraPassenger[index], obj, index)}
                                                        color='primary'
                                                        size='xs'
                                                        ms={{
                                                            position: 'absolute',
                                                            top: '8px',
                                                            right: '10px',
                                                            zIndex: '1'
                                                        }}>
                                                        -
                                                    </Button>
                                                    <TextField
                                                        value={extraPassenger[index]}
                                                        placeholder='0'
                                                        readonly={true}
                                                        ms={{
                                                            'input': {
                                                                textAlign: 'center'
                                                            }
                                                        }} />
                                                    <Button
                                                        onClick={() => increasePassengerNumber(maxExtraPersonCountResult, extraPassenger[index], obj, index)}
                                                        color='primary'
                                                        size='xs'
                                                        ms={{
                                                            position: 'absolute',
                                                            top: '8px',
                                                            left: '10px',
                                                            zIndex: '1'
                                                        }}>
                                                        +
                                                    </Button>
                                                </Box>
                                                {maxExtraPersonCountResult === 'empty' &&
                                                    <Typography
                                                        ms={{
                                                            lineHeight: '38px',
                                                            fontWeight: 'bold'
                                                        }}>
                                                        برای این اتاق نفر اضافه تعریف نشده است.
                                                    </Typography>
                                                }
                                            </Grid.Item>
                                        </Grid.Wrapper>
                                    </Grid>
                                </Box>
                            )
                        })}
                    </Box>
                </Box>
            }

        </React.Fragment>

    );

}

export default ExtraPassenger;